const state = {
    isFetched: false,
    language: '',
    content: {}
};
export default state;
